import { Box, FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import { useState } from 'react';

import FieldToolTip from 'components/forms/new/FieldToolTip';
import { Input } from 'components/v4';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const PasswordField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            isInvalid={!!errors.password && touched.password}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>Password</FormLabel>
                <Field
                    name="password"
                    render={({ field }) => (
                        <Box className="w-full pt-[15px]">
                            <Input
                                {...field}
                                type="password"
                                placeholder="Enter password"
                                className="!h-[30px] rounded-[5px] pl-2"
                            />
                        </Box>
                    )}
                />
                {isHovered && (
                    <FieldToolTip
                        label="The password associated with the SIP authentication username. Leave blank if your provider does not require authentication."
                        ariaLabel="registrar-password-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default PasswordField;
